import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface OrganizationSetupPageProps {
  onLogout: () => void | Promise<void>;
}

const OrganizationSetupPage: React.FC<OrganizationSetupPageProps> = ({ onLogout }) => {
  const navigate = useNavigate();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = async () => {
    setIsSigningOut(true);
    try {
      // App's logout revokes tokens (GlobalSignOut) and clears them from memory
      await onLogout();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-8 text-slate-900">
      <section className="mx-auto max-w-xl rounded-lg bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-semibold">Organization setup in progress</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Your organization is completing its setup. Please try again at a later time or contact your organization owner for an update.
        </p>
        <button
          type="button"
          onClick={handleSignOut}
          disabled={isSigningOut}
          className="mt-6 inline-flex items-center gap-2 rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white disabled:cursor-not-allowed disabled:opacity-60"
        >
          <LogOut size={16} aria-hidden="true" />
          {isSigningOut ? 'Signing out...' : 'Sign out'}
        </button>
      </section>
    </main>
  );
};

export default OrganizationSetupPage;
